import React from 'react';
import { FluidTabs } from '../../ui/fluid-tabs';
import { ViewAllButton } from '../../ui/view-all-button';
import { HomeAccommodationCard } from './HomeAccommodationCard';
import { HomeProductRail } from './HomeProductRail';
import { useHomeAccommodation, type HomeAccommodationTab } from './useHomeAccommodation';
import { WebCatalogUpdatingNotice } from '../WebCatalogUpdatingNotice';

const HomeAccommodation: React.FC = () => {
  const { t, activeTab, setActiveTab, featuredStays, onBookStay } = useHomeAccommodation();

  return (
    <section
      id="stays"
      className="home-product-type-section"
      style={{ background: '#ece3de' }}
    >
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-6 text-center md:mb-8">
          <h2
            className="font-felix-titling mb-3 text-3xl font-bold uppercase md:text-5xl"
            style={{
              letterSpacing: '-0.02em',
              color: 'rgba(30, 30, 30, 1)',
              fontWeight: 500,
            }}
          >
            {t('landing.accommodations.title') || 'Our Accommodations'}
          </h2>
          <p className="landing-section-subtitle">
            {t('landing.accommodations.subtitle') || 'Discover your perfect retreat in the heart of nature'}
          </p>
          <FluidTabs
            tabs={[
              { id: 'yourte', label: 'Yourte' },
              { id: 'chalet', label: 'Chalet' },
              { id: 'unite_rangée', label: 'Unite rangee' },
            ]}
            activeTab={activeTab}
            onTabChange={(tabId) => setActiveTab(tabId as HomeAccommodationTab)}
            className="mt-4"
          />
          <div className="mt-5 flex justify-center">
            <ViewAllButton
              to="/webdesigned/stays"
              label={t('landing.accommodations.viewAll') || 'View All Stays'}
            />
          </div>
        </div>
      </div>

      {featuredStays.length > 0 ? (
        <HomeProductRail
          resetKey={activeTab}
          aria-label={t('landing.accommodations.title') || 'Accommodations'}
        >
          {featuredStays.map((stay) => (
            <HomeAccommodationCard key={stay.id} stay={stay} t={t} onBook={onBookStay} />
          ))}
        </HomeProductRail>
      ) : (
        <div className="mx-auto max-w-7xl px-4">
          <WebCatalogUpdatingNotice />
        </div>
      )}
    </section>
  );
};

export default HomeAccommodation;
